// third-party
import { combineReducers } from 'redux';
import snackbarReducer from './state/data-slices/snackbar';
import userReducer from './state/data-slices/user';
import menuReducer from './state/data-slices/menu';
import admin from './state/reducer';
import accountReducer from './state/data-slices/accountSlice';
import { persistReducer, persistStore } from 'redux-persist';

// project imports
import storage from 'redux-persist/lib/storage';

// ==============================|| REDUX - MAIN STORE ||============================== //

const persistConfig =  {
    key: 'root',
    storage,
    keyPrefix: process.env.REACT_APP_PERSISTER_KEY ? process.env.REACT_APP_PERSISTER_KEY+'-' : 'mehuna-'
}

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    admin,
    account: persistReducer(persistConfig, accountReducer),
    snackbar: snackbarReducer,
    user: userReducer,
    menu: menuReducer
});

export default reducer;
